import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { baseUrl } from '.'

const url = `${baseUrl}/${import.meta.env.VITE_HELPDESK_API}`

export type SendHelpdeskEmailRequest = {
  name: string
  email: string
  phone: string
  subject: string
  message: string
  product?: number
  files?: FileList | File[] | null
}

export const sendHelpdeskEmail = (data: SendHelpdeskEmailRequest) => {
  if (data.files && data.files.length > 0) {
    const formData = new FormData()
    formData.append('Name', data.name)
    formData.append('Email', data.email)
    formData.append('Phone', data.phone || '')
    formData.append('Subject', data.subject)
    formData.append('Message', data.message)
    if (data.product !== undefined) {
      formData.append('Product', data.product.toString())
    }
    Array.from(data.files).forEach((file) => {
      formData.append('Files', file)
    })
    return apiClient.post(`${url}/SendHelpdeskEmail`, formData)
  }
  return apiClient.post(`${url}/SendHelpdeskEmail`, data)
}
